(function () {
  const SELECTORS = {
    bundleRoot: "[data-bundle-options]",
    bundleOption: "[data-bundle-option]",
    productFormEl: "product-form",
    addToCartForm: 'form[action="/cart/add"]',
    qtyInput: 'input[name="quantity"]',
    priceAmounts: ".product-price-container .amount",
  };

  function parseVariantIds(raw) {
    try {
      const arr = JSON.parse(raw);
      return Array.isArray(arr)
        ? arr.map((n) => String(n)).filter(Boolean)
        : [];
    } catch (e) {
      return [];
    }
  }

  function formatMoney(cents) {
    if (typeof window.Shopify?.formatMoney === "function") {
      const fmt = window.theme?.moneyFormat || "${{amount}}";
      return window.Shopify.formatMoney(cents, fmt);
    }
    const n = Number(cents);
    if (!Number.isFinite(n)) return null;
    return `$${(n / 100).toFixed(2)}`;
  }

  function setDisplayedPrice(root, cents) {
    const formatted = formatMoney(cents);
    if (!formatted) return;

    root.querySelectorAll(SELECTORS.priceAmounts).forEach((el) => {
      el.textContent = formatted;
    });

    const sectionId = root.querySelector(SELECTORS.productFormEl)?.dataset
      ?.section;
    if (sectionId) {
      [`price-${sectionId}`, `price-${sectionId}--sticky`].forEach((id) => {
        const node = document.getElementById(id);
        if (!node) return;
        node
          .querySelectorAll(".amount")
          .forEach((el) => (el.textContent = formatted));
      });
    }
  }

  function getSectionsToRender() {
    return [
      { id: "Cart", section: "main-cart", selector: ".thb-cart-form" },
      {
        id: "Cart-Drawer",
        section: "cart-drawer",
        selector: ".side-panel-content",
      },
      {
        id: "Cart-Drawer",
        section: "cart-drawer",
        selector: ".side-panel-footer",
      },
      {
        id: "cart-drawer-toggle",
        section: "cart-bubble",
        selector: ".thb-item-count",
      },
    ];
  }

  function getSectionInnerHTML(html, selector = ".shopify-section") {
    return (
      new DOMParser().parseFromString(html, "text/html").querySelector(selector)
        ?.innerHTML || ""
    );
  }

  function renderCartDrawer(resp) {
    const sectionsToRender = getSectionsToRender();

    sectionsToRender.forEach((e) => {
      const host = document.getElementById(e.id);
      if (!host) return;
      const target = host.querySelector(e.selector) || host;

      target.innerHTML = getSectionInnerHTML(
        resp.sections?.[e.section] || "",
        e.selector,
      );

      if (typeof CartDrawer !== "undefined") new CartDrawer();
      if (typeof Cart !== "undefined") new Cart().renderContents(resp);
    });

    const cartDrawer = document.getElementById("Cart-Drawer");
    if (cartDrawer) {
      document.body.classList.add("open-cc", "open-cart");
      cartDrawer.classList.add("active");
      if (typeof dispatchCustomEvent === "function")
        dispatchCustomEvent("cart-drawer:open");
    }
  }

  async function addBundleToCart({
    variantIds,
    quantity,
    sections,
    sectionsUrl,
  }) {
    const payload = {
      items: variantIds.map((id) => ({ id, quantity })),
      sections,
      sections_url: sectionsUrl,
    };

    const req = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const json = await req.json();
    return json;
  }

  function getCurrentVariantIdFromForm(addForm) {
    const idInput = addForm.querySelector('input[name="id"]');
    return idInput?.value ? String(idInput.value) : null;
  }

  function getCurrentDisplayedPriceCentsFromVariantSelects(root) {
    const vs = root.querySelector("variant-selects");
    const currentVariant = vs?.currentVariant;
    return currentVariant?.price != null ? Number(currentVariant.price) : null;
  }

  function wireBundleUI(root) {
    const bundleRoot = root.querySelector(SELECTORS.bundleRoot);
    if (!bundleRoot) return;

    const options = Array.from(
      bundleRoot.querySelectorAll(SELECTORS.bundleOption),
    );
    if (!options.length) return;

    const productFormEl = root.querySelector(SELECTORS.productFormEl);
    const addForm = productFormEl?.querySelector(SELECTORS.addToCartForm);
    if (!productFormEl || !addForm) return;

    const state = {
      selectedType: "default",
      selectedVariantIds: [],
      selectedPriceCents: null,
    };

    const defaultBtn =
      options.find(
        (b) => (b.getAttribute("data-bundle-type") || "") === "default",
      ) || null;

    function emitBundleChange(type, owner) {
      window.dispatchEvent(
        new CustomEvent("bundle:change", {
          detail: { type, owner: owner || "default" },
        }),
      );
    }

    function setSelected(btn) {
      options.forEach((b) => b.classList.toggle("is-selected", b === btn));

      const type = btn.getAttribute("data-bundle-type") || "bundle";
      state.selectedType = type;

      const ids = parseVariantIds(
        btn.getAttribute("data-bundle-variant-ids") || "[]",
      );
      state.selectedVariantIds = ids;

      const rawPrice = btn.getAttribute("data-bundle-price");
      const priceCents = Number(rawPrice);
      state.selectedPriceCents = Number.isFinite(priceCents)
        ? priceCents
        : null;

      if (state.selectedPriceCents != null) {
        setDisplayedPrice(root, state.selectedPriceCents);
      }

      if (type === "default") {
        emitBundleChange("default", "default");
      } else {
        emitBundleChange(
          "bundle",
          btn.getAttribute("data-bundle-owner") || "default",
        );
      }
    }

    function syncDefaultOptionToCurrentVariant() {
      if (!defaultBtn) return;

      const currentVariantId = getCurrentVariantIdFromForm(addForm);
      if (currentVariantId) {
        defaultBtn.setAttribute(
          "data-bundle-variant-ids",
          `[${currentVariantId}]`,
        );
      }

      const cents = getCurrentDisplayedPriceCentsFromVariantSelects(root);
      if (Number.isFinite(cents)) {
        defaultBtn.setAttribute("data-bundle-price", String(cents));
        if (state.selectedType === "default") setDisplayedPrice(root, cents);
      }
    }

    options.forEach((btn) =>
      btn.addEventListener("click", () => setSelected(btn)),
    );

    if (defaultBtn) setSelected(defaultBtn);
    syncDefaultOptionToCurrentVariant();

    root.addEventListener("product:variant-change", () => {
      syncDefaultOptionToCurrentVariant();
    });

    async function handleBundleSubmit(e, source) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function")
        e.stopImmediatePropagation();

      const atcButtons = root.querySelectorAll(".single-add-to-cart-button");
      atcButtons.forEach((b) => {
        if (!b.classList.contains("loading")) {
          b.setAttribute("aria-disabled", "true");
          b.classList.add("loading");
        }
      });

      const qtyEl = addForm.querySelector(SELECTORS.qtyInput);
      const quantity = Math.max(1, Number(qtyEl?.value || 1) || 1);

      const sections = getSectionsToRender().map((t) => t.section);
      const sectionsUrl = window.location.pathname;

      try {
        const resp = await addBundleToCart({
          variantIds: state.selectedVariantIds,
          quantity,
          sections,
          sectionsUrl,
        });

        if (resp?.status) {
          const errorWrapper = productFormEl.querySelector(
            ".product-form__error-message-wrapper",
          );
          const errorMsg = productFormEl.querySelector(
            ".product-form__error-message",
          );
          if (errorWrapper && errorMsg) {
            errorWrapper.toggleAttribute("hidden", false);
            errorMsg.textContent =
              resp.description ||
              resp.message ||
              "Unable to add bundle to cart.";
          }
          return;
        }

        renderCartDrawer(resp);

        if (typeof dispatchCustomEvent === "function") {
          dispatchCustomEvent("cart:item-added", {
            product: resp?.items?.[0] || resp,
          });
        }
      } catch (err) {
      } finally {
        atcButtons.forEach((b) => {
          b.classList.remove("loading");
          b.removeAttribute("aria-disabled");
        });
      }
    }

    productFormEl.addEventListener(
      "submit",
      (e) => handleBundleSubmit(e, "product-form element"),
      true,
    );

    addForm.addEventListener(
      "submit",
      (e) => handleBundleSubmit(e, "inner form"),
      true,
    );
  }

  function init() {
    const root =
      document.getElementById(
        "ProductInfo-template--19419671363674__main-product",
      ) ||
      document.querySelector(".product-information--inner") ||
      document;

    wireBundleUI(root);
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();
